const DialogApplicationBaseInfo = ({ ...props }) => {
  return <></>; //no need show it, because it is in left side
};

export default DialogApplicationBaseInfo;
